import { ApiMethodExecutingError } from '../../service/Errors';
import { ValidationResultItem } from '../../typings/common';

export const SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR = 'SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR';
export type SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR = typeof SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR;

export interface ShowUploadFileImportWizardRequestError {
    type: SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR;
    errors: ValidationResultItem[];
}

export function showUploadFileImportWizardRequestErrorAction(
    error?: ApiMethodExecutingError
): ShowUploadFileImportWizardRequestError {
    return {
        type: SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR,
        errors: error ? error.getErrors() : []
    };
}
